import { render, staticRenderFns } from "./forgot.component.vue?vue&type=template&id=533329e5&scoped=true"
import script from "./forgot.component.vue?vue&type=script&lang=js"
export * from "./forgot.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533329e5",
  null
  
)

export default component.exports